import { useState, useEffect } from 'react';

/**
 * Countdown do začátku směny.
 * Vrací { label, stav, totalMin } kde:
 *   label    — vždy kladná délka (např. "2d 5h", "5h 14m", "14m"). Směr (do/po
 *              startu) je v `stav`; konzumenti si volí wording ("Start za" vs
 *              "Zpoždění") podle stavu, aby se nebily fráze ("Start za · JIŽ BĚŽÍ").
 *   stav     — 'future' (>30 min do startu) | 'imminent' (≤30 min do startu)
 *              | 'started' (po cas_od; uživatel ještě nezačal směnu)
 *   totalMin — minuty do startu, kladné = ještě před, záporné = už po cas_od
 *
 * Update interval 30 s — pro mobilní display dostatečné a šetří CPU.
 */
export function useStartCountdown(smena) {
    const [data, setData] = useState({ label: '', stav: 'future', totalMin: 0 });

    useEffect(() => {
        if (!smena?.datum || !smena?.cas_od) {
            setData({ label: '', stav: 'future', totalMin: 0 });
            return;
        }

        const datum = typeof smena.datum === 'string' ? smena.datum.slice(0, 10) : smena.datum;
        const start = new Date(`${datum}T${(smena.cas_od || '00:00').slice(0, 5)}:00`);

        const update = () => {
            const totalMin = Math.floor((start - Date.now()) / 60000);
            const absMin = Math.abs(totalMin);

            const dny = Math.floor(absMin / 1440);
            const hod = Math.floor((absMin % 1440) / 60);
            const min = absMin % 60;

            let label;
            if (absMin < 1) {
                label = '< 1m';
            } else if (dny > 0) {
                label = `${dny}d ${hod}h`;
            } else if (hod > 0) {
                label = `${hod}h ${min}m`;
            } else {
                label = `${min}m`;
            }

            let stav;
            if (totalMin < 0) stav = 'started';
            else if (totalMin <= 30) stav = 'imminent';
            else stav = 'future';

            setData({ label, stav, totalMin });
        };

        update();
        const iv = setInterval(update, 30000);
        return () => clearInterval(iv);
    }, [smena?.datum, smena?.cas_od]);

    return data;
}
